import { CLIENT_LOGOS } from '@/content/social-proof';
import { useT } from '@/lib/useLang';

/**
 * Bandeau défilant infini. La liste est rendue deux fois à la suite et la piste
 * glisse de -50 % : quand la première copie sort, la seconde est exactement à
 * sa place, la boucle est donc sans couture. La seconde copie est `aria-hidden`
 * pour qu'un lecteur d'écran n'énonce pas chaque logo deux fois.
 *
 * Masquée tant que `CLIENT_LOGOS` est vide. Voir `content/social-proof.ts`.
 */
export function ClientLogos() {
  const t = useT();
  if (CLIENT_LOGOS.length === 0) return null;

  return (
    <section className="nz-logos">
      <div className="nz-container">
        <div className="nz-eyebrow">{t.trustedBy}</div>
      </div>
      <div className="nz-logos__marquee">
        <div className="nz-logos__track">
          {[0, 1].map((copy) => (
            <ul className="nz-logos__list" key={copy} aria-hidden={copy === 1 || undefined}>
              {CLIENT_LOGOS.map((logo) => (
                <li className="nz-logos__item" key={logo.name}>
                  {logo.src ? (
                    <img className="nz-logos__img" src={logo.src} alt={copy === 0 ? logo.name : ''} loading="lazy" />
                  ) : (
                    logo.name
                  )}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </section>
  );
}
